<template>
  <div class="t-no-format">
    <h3 class="t-no-format__title" v-html="$root.staticText.noFormat"></h3>
    <p v-html="$root.staticText.noFormatText"></p>
  </div>
</template>

<script>
export default {
  name: 'noFormat',
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/noFormat.vue